import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';

import { Col } from 'components/grid';
import { Container, StyledTab, TabsContainer } from './styles';

const useQuery = () => new URLSearchParams(useLocation().search);

const Tabs = ({ tabs }) => {
  const [activeTabIndex, setActivetabIndex] = useState(0);
  const queryParams = useQuery();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const actualPath = `${location.pathname}${location.search}`;

    for (let i = 0; i < tabs.length; i += 1) {
      if (tabs[i].path === actualPath) {
        setActivetabIndex(i);
        break;
      }
    }
  }, [queryParams]);

  const handleClickTab = (tab) => {
    history.push(tab.path);
  };

  return (
    <Container>
      <TabsContainer>
        {tabs.map((tab, index) => (
          <StyledTab
            key={tab.title}
            active={index === activeTabIndex}
            onClick={() => handleClickTab(tab)}
          >
            {tab.title}
          </StyledTab>
        ))}
      </TabsContainer>
      <Col col={12}>
        <div>
          {tabs[activeTabIndex].component}
        </div>
      </Col>
    </Container>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
};

export default Tabs;
